import { useIsTopLevelFeaturePage } from '@ms/yammer-hooks/dist/navigation';
import { useIsVivaEngageApp } from 'hooks/useIsVivaEngageApp';

type UseShouldHaveHeroBanner = () => boolean;
export const useShouldHaveHeroBanner: UseShouldHaveHeroBanner = () => {
  const isVivaEngageApp = useIsVivaEngageApp();
  const isTopLevelFeaturePage = useIsTopLevelFeaturePage();

  return isVivaEngageApp && isTopLevelFeaturePage;
};
